import { BASE } from "./index";
import axios from "./http";

const classification = {
    //排序
    categoriestagsortsave: (params) => axios.post(`${BASE.PRO1}/categories/tag/sort/save`, params),
    //隐藏
    categoriestagchangestatus : (params) => axios.post(`${BASE.PRO1}/categories/tag/change/status`, params),
 
};

export default classification;
